<template>
  <div class="wel-banner">
    <div>
      {{ $t('header1') }}
      <div class="wel-banner__highlight">{{ $t('header2') }}</div>
      <!-- <div class="welcome-banner__highlight">{{$t('header3')}}</div> -->
    </div>
    <div class="wel-banner__highlight2">
      {{ headerTitle }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headerTitle: ''
  }
};
</script>

<style lang="scss" scoped>
// .welcome-banner {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   font-size: 14px;
//   font-weight: bold;
//   padding: 16px 30px;

//   &__highlight {
//     font-size: 24px;
//   }
//   &__highlight2 {
//     font-size: 40px;
//   }
// }
</style>

<i18n
  src="@/locales/components/PageHeading.json"
/>

